import React from 'react';
import { useOnlyWithoutStatusDetections } from '../../../contexts/predictions.hooks';
import { Toggler } from '../../Toggler';

export function ToggleDetectionsStatusDisplayButton() {
  const [onlyWithoutStatus, setOnlyWithoutStatus] =
    useOnlyWithoutStatusDetections();

  return (
    <Toggler checked={onlyWithoutStatus} onChange={setOnlyWithoutStatus}>
      Filter pending detections
    </Toggler>
  );
}
